module.exports = __webpack_public_path__ + "static/media/meditation_icon.a51b5e9f.png";